import type { Localization } from './Localization';

export type QuoteItem = {
	title: Localization;
	quote: Localization;
	image: {
		src: string;
	};
};

export const asideQuotes: QuoteItem[] = [
	{
		title: (t) => t('aside.quote.1.title'),
		quote: (t) => t('aside.quote.1.quote'),
		image: {
			src: '/assets/quotes/wolfgang.jpg',
		},
	},
	{
		title: (t) => t('aside.quote.2.title'),
		quote: (t) => t('aside.quote.2.quote'),
		image: {
			src: '/assets/quotes/teyna.jpg',
		},
	},
];
